module.exports = __webpack_public_path__ + "img/safety-bg.e4a38ef5.png";